import React, { memo } from 'react';
import { StyledSearch } from './styles';
import i18n from '../../i18';
import { IconButton, InputAdornment } from '@mui/material';
import Iconify from '../iconify';
import { SearchNormal1LinearIcon } from '../../icons-lib';
import PropTypes from 'prop-types';

export function SearchInput({ searchValue, handleSearchData, sx, disabled }) {
    const handleCloseSearch = () => {
        handleSearchData('');
    };
    return (
        <StyledSearch
            disabled={disabled}
            sx={sx}
            value={searchValue}
            onChange={(event) => handleSearchData(event.target.value)}
            placeholder={i18n.t('text.search')}
            startAdornment={
                <InputAdornment position="start">
                    <SearchNormal1LinearIcon
                        sx={{ width: '14px', height: '14px' }}
                    />
                </InputAdornment>
            }
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        edge="end"
                        onClick={() => handleCloseSearch()}
                        disabled={disabled}
                    >
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </InputAdornment>
            }
        />
    );
}
SearchInput.propTypes = {
    searchValue: PropTypes.string.isRequired,
    handleSearchData: PropTypes.func.isRequired,
    sx: PropTypes.object
};
export default memo(SearchInput);
